import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { thunkFetchPodcasts } from '@/redux/actions';
import Select from 'components/Select';

const PodcastsPicker = props => {
	const { event, podcasts, route, fetchPodcasts, handlePickItem } = props;
	const [selectedPodcast, setSelectedPodcast] = useState([]);

	useEffect(() => {
		if (route && route.includes('podcasts')) {
			const podcastKey = route.split('/');
			const podcastID = +podcastKey[podcastKey.length - 1];
			setSelectedPodcast([podcastID]);
		}
	}, [route]);

	const handleSetPodcast = podcastID => {
		const podcast = podcasts.find(pod => +pod.id === +podcastID);
		handlePickItem({
			route: `/podcasts/${podcastID}`,
			name: podcast.name,
		});
	};

	useEffect(() => {
		fetchPodcasts({ event_id: event.id }, 'useEffect - PodcastsPicker');
	}, []);

	return (
		<div className="podcasts-picker-container">
			<Select
				data={podcasts}
				onChange={handleSetPodcast}
				value={selectedPodcast || []}
				placeholder="Select a Podcast Episode"
				type="podcasts"
			/>
		</div>
	);
};

const msp = ({ podcasts }) => ({
	podcasts: podcasts.podcasts,
});

const mdp = dispatch => ({
	fetchPodcasts: (queryParams, from) => dispatch(thunkFetchPodcasts(queryParams, from)),
});

export default connect(msp, mdp)(PodcastsPicker);
